import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';

export class ReplaceUpgrader {
    private filePath: string;
    private fileWriter: FileWriter;
    private replaces: any;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     * @param replaces the replaces.
     * @param fileName the file name.
     */
    constructor(filePath: string, replaces: any, fileName?: string) {
        this.filePath = filePath;
        this.replaces = replaces;

        this.messages.notFound = `${fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .replaceContent(this.replaces)
                    .writeFile();
            } else {
                    Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
